export default {
    title: '수업 결과',

    sessionInfo: {
        title: '기본 정보',
        items: {
            date: '{mode} 일자',
            duration: '진행 시간',
            studentCount: '참여',
        },
        durationFormat: '{startTime} ~ {endTime} ({duration}분)',
    },
    curriculumInfo: {
        title: '수업명',
        selfModeTitle: '자습명',
        taskModeTitle: '과제명',
    },

    summary: {
        title: '활동 정보',
        completedActivity: '진행한 활동',
        headers: {
            activity: '활동',
            achievement: '성취도',
        },
    },

    studentResults: {
        title: '학생별 정답 개수 및 MVP',
        mvp: 'MVP',
        headers: {
            student: '학생',
            answers: '정답 수',
            score: '점수',
        },
    },

    actions: {
        close: '창 닫기',
        print: '인쇄하기',
        export: '내보내기',
    },

    errors: {
        windowClose: '오류가 발생했습니다. 창을 직접 닫아주세요.',
    },
};
